import { RadioGroup } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
export default function PaymentMethod({
  register,
  setValue,
  setCurrentStep,
  policy,
}) {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);

  const onSubmit = () => {
    if (policy?.modalPremiumAmountTotal) {
      setValue("method", "CC");
      setCurrentStep(4);
      setIsChecked(true);
    }
  };
  useEffect(() => {
    onSubmit();
  }, [policy]);

  return (
    <>
      <div className="px-0 md:px-16">
        <RadioGroup className="ui-form-card-row">
          <RadioGroup.Option
            id="ID_methodStep1Option1"
            className={({ checked }) =>
              `${
                checked || isChecked ? "ui-form-card selected" : "ui-form-card"
              }  `
            }
            {...register("method")}
            tabIndex="0"
            aria-label="Select to pay this policy"
            aria-controls="ID_methodStep1Option1"
            aria-expanded="false"
            checked={isChecked}
            onClick={(e) => {
              onSubmit();
            }}
          >
            {({ checked }) => (
              <>
                <RadioGroup.Label
                  className="block text-xxs mb-1 pr-8 cursor-pointer font-semibold"
                  as="p"
                >
                  {t("UnauthMakeAPayment-paymentmethod-cc")}
                </RadioGroup.Label>

                <div className="text-xxs font-semibold pr-8 group-hover:underline">
                  <div className="ui-form-card-checkbox">
                    <svg
                      className="ui-icon w-2 h-2 text-white hidden"
                      focusable="false"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-checkmark"></use>
                    </svg>
                  </div>
                </div>
              </>
            )}
          </RadioGroup.Option>
        </RadioGroup>
      </div>
    </>
  );
}
